import AscAnserToolContainer from '../anserTool/containers/AscAnserToolContainer.vue'
import AscDerivedParameterListContainer from '../derivedParameters/containers/AscDerivedParameterListContainer.vue'
import AscCustomAlertsGridContainer from '../customAlerts/containers/AscCustomAlertsGridContainer.vue'
import AscAscentiaAnalyticsListContainer from '../ascentiaAnalytics/containers/AscAscentiaAnalyticsListContainer.vue'

import Index from './Index.vue'
import { role } from '@/utilities/userRoles'
import { permission } from '@/utilities/userPermissions'

const anserToolRouter = [
  {
    icon: 'mdi-chart-timeline-variant',
    path: '',
    name: 'Analytics',
    display: true,
    component: Index,
    meta: {
      primaryNavigation: true,
    },
    children: [
      {
        path: '/custom-analytics',
        name: 'Custom Analytics',
        display: true,
        component: AscCustomAlertsGridContainer,
        meta: {
          primaryNavigation: true,
          requiresRole: [role.airlineUser, role.acmfUser],
          breadcrumbs: [
            {
              text: 'Home',
              to: '/',
            },
            {
              text: 'Custom Analytics',
            },
          ],
        },
      },
      {
        path: '/analytics-developer',
        name: 'Analytics Developer',
        display: true,
        component: AscAnserToolContainer,
        meta: {
          primaryNavigation: true,
          requiresRole: role.anserUser,
          tooltip: 'ANALYTICS DEVELOPER',
          breadcrumbs: [
            {
              text: 'Home',
              to: '/',
            },
            {
              text: 'ANALYTICS DEVELOPER',
            },
          ],
        },
      },
      {
        path: '/custom-parameters',
        name: 'Custom Parameters',
        component: AscDerivedParameterListContainer,
        display: true,
        meta: {
          primaryNavigation: true,
          requiresRole: [role.airlineUser],
          requiresPermission: [permission.derivedParametersFullFlight],
          breadcrumbs: [
            {
              text: 'Home',
              to: '/',
            },
            {
              text: 'Custom Parameters',
            },
          ],
        },
      },
      {
        icon: 'mdi-chart-timeline-variant',
        path: '/ascentia-analytics',
        name: 'Ascentia Analytics',
        html: 'Ascentia<sup>&reg;</sup> Analytics',
        display: true,
        component: AscAscentiaAnalyticsListContainer,
        meta: {
          primaryNavigation: true,
          tooltip: 'ASCENTIA® ANALYTICS',
          breadcrumbs: [
            {
              text: 'Home',
              to: '/',
            },
            {
              text: 'ASCENTIA ANALYTICS',
            },
          ],
        },
      },
    ],
  },
]

export default anserToolRouter
